/**
 * Created with IntelliJ IDEA.
 * User: elinar
 * Date: 12/9/14
 * Time: 7:29 PM
 * To change this template use File | Settings | File Templates.
 */

define({
    TABS: {
        CONTENT: "content",
        CHAT: "chat",
        TICKET: "ticket",
        NOTIFICATION: "notification"
    },
    USAGE_TO_TRACK: {
        CONTENT: {
            CLICK_TO_CONTENT: "click_to_content",
            DIRECT_LINK_TO_CONTENT: "direct_link_to_content",
            OPEN_ARTICLE_CONTEXTUAL_LIST: "open_article_contextual_list",
            OPEN_ARTICLE_RELATED_LIST: "open_article_related_list",
            OPEN_ARTICLE_SEARCH_LIST: "open_article_search_list",
            OPEN_ARTICLE_RECENT_LIST: "open_article_recent_list",
            GET_CONTENT_IN_CHAT: "get_content_in_chat",
            OPEN_CONTENT_IN_CHAT: "open_content_in_chat"
        },
        CHAT: {
            CLICK_TO_CHAT_GROUP: "click_to_chat_group",
            CLICK_TO_CHAT_USER: "click_to_chat_user",
            DIRECT_LINK_TO_CHAT_GROUP: "direct_link_to_chat_group",
            DIRECT_LINK_TO_CLICK_TO_CHAT_USER: "direct_link_to_click_to_chat_user"
        },
        SEARCH: {
            SEARCH_CONTENT_KEY: "search_content_key",
            SEARCH_CHAT_KEY: "search_chat_key"
        },
        MYCASES: {
            FILTER_CASES: "mycases_filter_cases_keys",
            OPEN_ONE_CASE: "mycases_open_one_case",
            OPEN_ONE_CASE_FROM_EXTENDED: "mycases_open_one_case_from_extended_list",
            SEARCH_CASES: "mycases_search_cases",
            OPEN_EXTENDED: "mycases_open_extended_list",
            CLOSE_CASE: "mycases_close_case"
        },
        MY_NOTIFICATIONS: {
            OPEN_ONE_NOTIFICATION: "my_notifications_open_one_notification",
            REMOVE_ONE_NOTIFICATION: "my_notifications_remove_one_notification"
        }

    },
    CONTACT_TYPE: {
        USER: "user",
        GROUP: "group"
    },

    CONTACT_TYPES: {
        USER: "user",
        GROUP: "group",
        ALL: "all"
    },

    CONTACT_STATES: {
        OFFLINE: 1,
        ONLINE: 2,
        BUSY: 3,
        AWAY: 4
    },
    CONTACT_STATES_ORDER: {
        ONLINE: 1,
        BUSY: 2,
        AWAY: 3,
        OFFLINE: 4
    },
    CONTACT_DEFAULT_AVATAR: window.leImageBaseUrl + "src/modules/user-management/assets/img/avatar200x200.png",
    CHAT_TAB_STATES: {
        CONTACTS_LIST: 1,
        SURVEY_WINDOW: 2,
        CHAT_WINDOW: 3
    },
    CONVERSATION_IFRAME_STATE: {
        CHAT: 1,
        MESSAGING: 2,
        NONE: 3
    },
    CHAT_LINE_SOURCES: {
        "VISITOR": "visitor",
        "AGENT": "agent",
        "SYSTEM": "system"
    },
    CHAT_LINE_TYPES: {
        "VISITOR": "visitor",
        "AGENT": "agent",
        "ANOTHER_AGENT": "agent2",
        "INFO": "system",
        "ERROR": "warning",
        "CHAT_DIVIDER": "divider",
        "SNIPPET": "snippet",
        "COBROWSE": "cobrowse"
    },
    CHAT_STATES: {
        "CHATTING": "chatting",
        "ENDED": "ended",
        "INITIALISED": "initialised",
        "NOTFOUND": "notfound",
        "PAUSECHAT": "paused",
        "RESUMEPAUSEDCHAT": "resumepaused",
        "RESUMING": "resume",
        "UNINITIALISED": "uninitialised",
        "WAITING": "waiting"
    },
    CONVERSATION_TYPES: {
        "CHAT": "chat",
        "MESSAGING": "messaging"
    },
    CHAT_DEFAULT_USER_NAME: "you",
    CHAT_API_ERROR_CODES: {
        UNAVAILABLE: 32
    },
    CHAT_ERROR_TYPES: {
        UNAVAILABLE: "unavailable",
        GENERAL: "general",
        SURVEY_INVALID: "survey_invalid",
        GROUP_NOT_FOUND: "group_not_found"
    },
    CHAT_MODE: {
        NORMAL: 1,
        FALLBACK: 2
    },
    CHAT_RECONNECT: {
        WAIT_TIME: 5000,
        RETRY_COUNT : 3
    },
    ENGAGEMENTS_WAIT_TIME: 180000,
    SURVEY_QUESTION_TYPE_NAMES: {
        "CHECKBOX": "checkbox",
        "RADIO": "radio",
        "RADIOH": "horizontalradio",
        "SELECT": "dropdown",
        "TEXT": "text",
        "TEXTF": "textfield"
    },
    RECENT: {
        "SNIPPET_LIMIT": 8
    },
    AREA: {},
    PAGE: {
        ARTICLE: "article",
        TICKET: "ticket",
        NOTIFICATION: "notification"
    },
    ARTICLE: {
        "STATE": {
            "OPEN": true,
            "CLOSED": false
        }
    },
    CHAT_INITIATED_SOURCE: {
        USER: 1,
        RESUME: 2,
        SYSTEM: 3
    },
    SURVEY_TYPES: {
        "OFFLINE": 1,
        "PRECHAT": 2,
        "EXIT": 3
    },
    REFERER_ACTION: {
        NEW_SNIPPET: "newsSnippet",
        PAGE_SNIPPET: "pageSnippet",
        AREA_SNIPPET: "areaSnippet",
        RECENT_SNIPPET: "recentSnippet",
        SEARCH_RESULTS_SNIPPET: "searchResultsSnippet",
        RELATED_SNIPPET: "relatedSnippet",
        DIRECT_LINK_TO_CONTENT: "directLinkToContent",
        CLICK_TO_CONTENT: "clickToContent",
        CANNED_RESPONSE: "cannedResponse",
        CLICK_TO_CHAT: "clickToChat",
        USER: "user",
        ERROR: "error",
        REFRESH: "REFRESH"
    },

    ARTICLE_STATUS: {
        LOADING: "loading",
        ERROR: "error",
        SUCCESS: "success",
        NONE: "none"
    },
    DIRECT_LINKS: {
        ARTICLE: "connectionOpenArticle",
        SKILL: "connectionChatWithSkill"
    },

    SNIPPET_PERMUTATION: {
        PANEL: 1,
        RELATED: 2,
        CHAT: 3
    },
    CP_VISIBILITY: {
        ALL: 0,
        CHAT_NOT_AGENTS: 1,
        NONE: 2,
        //these characteristics are a workaround and will be replaced as soon as the new permission model is used
        ADMIN_ONLY: 3,
        ARTICLES: 4,
        ALL_BUT_AGENTS: 5
    },
    CASES_VISIBILITY: {
        ALL: "all",
        ALL_BUT_AGENT: "allButAgents",
        ADMIN: "admin",
        NONE: "none"
    },
    VISIBILITY: {
        KP: "isKPVisible",
        CHAT: "isChatVisible",
        CASES: "isCaseManagementVisible",
        CREATE_CASE: "isAllowCreateCases",
        NOTIFICATION_CENTER: "isNotificationCenterVisible"
    },
    AC_FEATURE: {
        CP_VISIBILITY: "LEUI.ConnectionBar_Display",
        CASES_VISIBILITY: "LEUI.ConnectionBar_CaseManagement_Visible"
    },
    ATTACHMENTS: {
        MAX_SIZE: 5242880,
        UPLOAD_TIMEOUT: 120000
    },
    NOTIFICATIONS: {
        FETCH_INTERVAL_REST: 30000,
        AUTH_INDICATOR: 'authenticated',
        MSG_PREFIX: 'message',
        AUTH_JSON_STRING: '{"message":"authentication", "data": { "bearer" : "{bearer}", "accountId": "{accountId}", "userId": "{userId}"}}',
        LOCAL_STORAGE_VAR: 'notifyColl',
        PING: {message:"ping"},
        PONG: {message:"pong"},
        MESSAGING_SUBSCRIPTION: 'messagingSubscribe'
    },

    MESSAGING_NOTIFICATIONS: {
        FETCH_INTERVAL: 10000,
        INITIAL_FETCH_DELAY: 5000
    }
});

